﻿{
  "community": {
    "name": "Comunidad",
    "titles": {
      "1": "Comunidad en línea",
      "2": "Encuentre materiales",
      "3": "Comparta lo que ha creado"
    },
    "body": {
      "1": "Es un excelente lugar donde zambullirse y ver todo lo que ofrece Boardmaker.",
      "2": "Vea lo que otros están creando y compartiendo. ¡Es como una ventana hacia la magia de Boardmaker!",
      "3": "Usando su software de Boardmaker favorito, cargue y comparta lo que ha creado con la comunidad."
    }
  },
  "personal": {
    "name": "Personal",
    "header": "Incluye todo lo del Plan Comunitario y más:",
    "titles": {
      "1": "Cree, edite, reproduzca e imprima",
      "2": "Software de Boardmaker"
    },
    "body": {
      "1": "Ideal para los padres o cuidadores que tengan un niño y que deseen crear, editar, reproducir e imprimir las actividades.",
      "2": "Las cuentas vienen con una licencia de Boardmaker 7 que se puede instalar hasta en 2 computadoras con Windows."
    }
  },
  "professional": {
    "name": "Profesional",
    "header": "Incluye todo lo del Plan Personal y más:",
    "titles": {
      "1": "Administrador de estudiantes",
      "2": "Configuraciones individualizadas"
    },
    "body": {
      "1": "Ideal para los instructores que tengan entre 1 a 50 estudiantes, que deseen asignar tareas y realizar el seguimiento de la información de los estudiantes.",
      "2": "Permite una configuración de acceso personalizada para cada estudiante."
    }
  },
  "organization": {
    "name": "Organización",
    "header": "Incluye todo lo del Plan Profesional y más:",
    "titles": {
      "1": "Soporte de un equipo multidisciplinario"
    },
    "body": {
      "1": "Ofrece precios por volumen. La organización controla la información y varias personas pueden asignar tareas a los mismos estudiantes."
    }
  }
}
